import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAssetsData } from 'store/api/cuverse-api/assets/types/assets-response.interface';
import { TFetchStatus } from 'types/api/fetch-status.type';

import { requestAssetsData } from './assets.thunk-actions';

export interface IAssetsState {
  assets: TAssetsData;
  isOnlyTrialMinersInAssets: boolean | undefined;

  status: TFetchStatus;

  error: string | null;
}

export const initialState: IAssetsState = {
  assets: [],
  isOnlyTrialMinersInAssets: false,
  status: 'initial',

  error: null,
};

const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestAssetsData.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(requestAssetsData.fulfilled, (state, action: PayloadAction<TAssetsData>) => {
        state.status = 'fulfilled';
        state.assets = action.payload;

        const trialMinersLength = action.payload.filter((miner) =>
          miner.assetName.toLocaleLowerCase().includes('trial'),
        ).length;
        const minersLength = action.payload.filter(
          (miner) => !miner.assetName.toLocaleLowerCase().includes('trial'),
        ).length;

        if (trialMinersLength === 0 && minersLength === 0) {
          return;
        }

        state.isOnlyTrialMinersInAssets = trialMinersLength > 0 && minersLength === 0;
      })
      .addCase(requestAssetsData.rejected, (state, error) => {
        state.status = 'rejected';
        state.error = JSON.stringify(error);
      });
  },
});

export const assetsReducer = assetsSlice.reducer;
